export default "__VITE_ASSET__f13a28fd__"